import React from 'react';
import { Alert, Form, PrintPDF } from '../../components';
import ApiService from '../../services/api.service';

interface IProps { 
    history?: any;
    id?: number;
    caption?: string;
    captionColor?: any;
    captionThin?: boolean;
    buttonCaption?: string;
    proccessCaption?: string;
    endPointFilter?: string;
    model: any;
    onLoad?: (data: any) => void;
    printOptions?: any;
    htmlId: string;
    save?: boolean;
    onSaveBefore?: () => void;
    onSave?: (data: any) => void;
    onLoadFile?: (data: any) => void;
    buttonOnBottom?: boolean;
    cardColor?: any;
    cardGradientColor?: any;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}

interface IState {
    endPointFilter: string;
    save: boolean;
}

export default class BasePreview extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            endPointFilter: props.endPointFilter || '',
            save: false,
        }
    }

    private id = this.props.id?.toString() || this.props.history?.location.state?.id || '';
    private isLoading: boolean = false;
    
    private onSave = async() => {
        await this.props.onSaveBefore?.();
        this.setState({save: true});
    }

    private onSavePdf = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data);
    }
    
    public componentDidMount() { 
        
        if (this.isLoading) return;
        this.isLoading = true;

        ApiService.get<typeof this.props.model>(this.props.model.endPoint + (this.props.endPointFilter || '?populate=*&filters[id]='), this.id)
        .then(rp => {
            if (rp.Status) {
                const data = rp.Data.length === 0? this.props.model.defaultValue() : new this.props.model(rp.Data[0]); 
                this.props.onLoad?.(data);
            } 
            else Alert(this.context, rp.Messages, 'error');
            this.isLoading = false;
        });
    }

    public componentDidUpdate() {
        if (!this.isLoading)
            if (this.props.endPointFilter && this.state.endPointFilter !== this.props.endPointFilter) {
                this.setState({endPointFilter: this.props.endPointFilter})
                this.componentDidMount();
            }

        if (this.props.save) this.onSave();
    }

    render() {
        
        return (
            <>
            <Form history={this.props.history} caption={this.props.caption || 'Preview ' + this.props.model.caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin} buttonCaption={this.props.buttonCaption || 'save'} buttonOnBottom={this.props.buttonOnBottom} onSubmit={this.onSave} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
                {this.props.children}
            </Form>
            {this.props.printOptions?.type==='pdf' && 
                <PrintPDF htmlId={this.props.htmlId} printOptions={this.props.printOptions} caption={this.props.proccessCaption} save={this.state.save} onLoad={this.props.onLoadFile} onSave={this.onSavePdf}/>
            }
            </>
        );
    }
}